module.exports = __webpack_public_path__ + "img/no_dp.064a17ba.png";